<template>
  <div class="kalendar-event-types">
    <div class="open-folder-line">
      <div :class="['open-folder-line-left', tab_name == 'rocista' || tab_name == 'kalovi' ? 'rocisnik-line' : '']">
        <div class="posta-dropdown" v-if="tab_name != 'rocista' && tab_name != 'kalovi'">
          {{ $t("components.calendar.filter") }}:
          <select class="drop-filter" id="search-group multiple" v-model="select_event_type">
            <option v-for="(ev_type, key) in filter_event_type" :key="key" :value="ev_type.id">
              {{ ev_type.naziv }}
            </option>
          </select>
          <!-- <input type="submit" value="Submit" /> -->
          <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
        </div>

        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
          max-width="290px" min-width="auto" v-if="tab_name == 'rocista' || tab_name == 'kalovi'">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateRangeText" readonly clearable label="Odaberite period" v-bind="attrs"
              @click="menu1 = !menu1" v-on="on" class="case-date-picker rocista-date-picker"></v-text-field>
          </template>
          <v-date-picker locale="hr" :first-day-of-week="1" v-model="date_range"  range no-title :pickerDate.sync="pickerDate"></v-date-picker>
        </v-menu>
        <div v-if="tab_name == 'rocista' || tab_name == 'kalovi'" class="rocisnik-info">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M0 9.99927C0 4.48027 4.48 -0.000732422 10 -0.000732422C15.53 -0.000732422 20 4.48027 20 9.99927C20 15.5203 15.53 19.9993 10 19.9993C4.48 19.9993 0 15.5203 0 9.99927ZM9.12 6.20927C9.12 5.73027 9.52 5.32927 10 5.32927C10.48 5.32927 10.87 5.73027 10.87 6.20927V10.6293C10.87 11.1103 10.48 11.4993 10 11.4993C9.52 11.4993 9.12 11.1103 9.12 10.6293V6.20927ZM10.01 14.6803C9.52 14.6803 9.13 14.2803 9.13 13.8003C9.13 13.3203 9.52 12.9303 10 12.9303C10.49 12.9303 10.88 13.3203 10.88 13.8003C10.88 14.2803 10.49 14.6803 10.01 14.6803Z"
              fill="#FD4087" />
          </svg>
          <span v-if="tab_name == 'rocista'">{{ date_range.length > 0 ? 'Prikazuju se sva ročišta organizacije u odabranom periodu' : 'Prikazuju se sva nadolazeća ročišta organizacije'}}</span>
          <span v-if="tab_name == 'kalovi'">{{ date_range.length > 0 ? 'Prikazuju se svi Kalovi u odabranom periodu' : 'Prikazuju se svi nadolazeći Kalovi'}}</span>
          <div class="vertical-divider"></div>
          <div class="generiraj-rocisnik-button" @click="generateReport">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
              <path d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297" stroke="#2B2B41"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <circle cx="17.9954" cy="3.20027" r="1.9222" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788"
                stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>{{ $t("components.calendar.event_list_component.report_btn") }}</span>
          </div>
        </div>
      </div>
      <Pagination v-show="all_events.length != 0" ref="paginat" :finalni_arr_prikaza.sync="finalni_arr_prikaza" :br_redova="br_redova" :ukupna_lista="all_events"/>
    </div>

    <div v-if="fetching" class="paznja-spinner">
      <svg class="dot-spin" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
    </div>
    <div v-if="all_events.length > 0" class="event-list-wrapper" :key="refreshKey">
      <EventCard v-for="(single_event, key) in finalni_arr_prikaza" :key="key" :single_event="single_event"
        :event_wrapper_class="'events-tab-view'" :tab_name="tab_name" />
    </div>
    <div v-if="!fetching && all_events.length == 0" class="event-list-wrapper">
      <div class="poruka-empty">
        {{ $t("components.calendar.event_list_component.no_available") }}
      </div>
    </div>

  </div>
</template>

<script>
import EventCard from "@/components/calendarComponents/EventCard.vue";
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import person from "@/apiCallers/promise_handler_db/person";
import auth from "@/services/auth";
import moment from "moment";
import DataLoader from '@/components/generalComponents/DataLoader'
import Pagination from "@/components/generalComponents/Pagination.vue";

export default {
  props: ["tab_name"],
  components: {
    EventCard,
    DataLoader,
    Pagination
  },
  data() {
    return {
      rasporedi_liste: [[], [], []],
      all_events: [],
      accessToken: "",
      filter_event_type: [{ naziv: this.$t("components.calendar.filter_event_type")[0].naziv, id: 0 }],
      select_event_type: 0,
      fetching: true,
      refreshKey: 0,
      finalni_arr_prikaza: [],
      br_redova: 9,
      menu1: false,
      date_range: [],
      pickerDate: null,
      first_open: true,
    };
  },
  watch: {
    select_event_type: function () {
      this.fetchData();
    },
    date_range: function () {
      this.fetchData()
    },
    pickerDate: function () {
      let is_same_month = false;
      if (this.date_range.length == 2)
        is_same_month = (moment(this.date_range[0]).month() == moment(this.date_range[1]).month())
      else if (this.date_range.length == 0)
        is_same_month = true

      if (!this.first_open && is_same_month) {
        let listed_date = []
        listed_date.push(moment(this.pickerDate).startOf("month").format("YYYY-MM-DD"));
        listed_date.push(moment(this.pickerDate).endOf("month").format("YYYY-MM-DD"));
        this.date_range = listed_date
        // console.log(listed_date)
      } else
        this.first_open = false
    },
  },
  computed: {
    dateRangeText: {
      get() {
        var ret_date_string = [];
        this.date_range.forEach((p) => {
          ret_date_string.push(moment(p).format("l"));
        });
        return ret_date_string.join(" ~ ");
      },
      set(new_val) {
        // console.log(new_val)
        if (new_val == null) {
          this.date_range = [];
        }
      }
    },
  },
  methods: {
    generateReport() {
      this.$store.state.rocista_report_data.events = this.all_events;
      this.$store.state.rocista_report_data.razdoblje = this.dateRangeText;
      if (this.tab_name == 'kalovi') {
        this.$store.state.current_report_type = 'kalovi';
      }
      else{
        this.$store.state.current_report_type = 'rocista'
      }
      this.$router.push({ name: 'RocistaReport' });
      // let routeData = this.$router.resolve({name: 'RocistaReport',  query: {rocista: {...this.all_events}}});
      // window.open(routeData.href, '_blank');
    },
    async fetchData() {
      // TO DO dohvatiti prave podatke ovisno o tabu
      this.all_events = [];
      this.fetching = true;
      this.accessToken = this.$store.state.aToken 
      let lawyer_id = await person.getSelf(this.accessToken);
      lawyer_id = lawyer_id.data.uid;
      (this.rasporedi_liste = [[], [], []]), (this.raspon_datuma = []);
      var start_date = null;
      var end_date = null;
      var temp_date = [...this.date_range].sort((a, b) => new Date(a) - new Date(b))
      if (temp_date.length > 0) {
        start_date = temp_date[0];
        if (temp_date.length > 1) {
          end_date = temp_date[1];
        }
      }



      await ms_calendar
        .getPersonCalendarList(
          this.accessToken,
          lawyer_id,
          this.select_event_type,
          this.tab_name,
          start_date,
          end_date
        )
        .then((resp) => {
          // console.log(resp.data);
          this.rasporedi_liste[2] = resp.data;
          this.fetching = false;
          this.all_events = this.rasporedi_liste[2];
          setTimeout(() => {
            this.$refs.paginat.calculatePageNumber();
            this.$refs.paginat.paginirajOdabrane();
          }, 10);
        });

    },
  },
  async created() {
    await this.fetchData();

    await ms_calendar.getEventType().then((resp) => {
      resp.data.map((ev) => this.filter_event_type.push({ naziv: ev.name, id: ev.uid }));
    });
    if (this.tab_name == 'rocista') {
      this.$store.state.rocista_tab_active = true;
    }
    else {
      this.$store.state.rocista_tab_active = false;
    }
  },
  mounted() {

  },
};
</script>